var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMonitorNavigation = function SvgMonitorNavigation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "#4F4E65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4L12.5 2.5C18.5001 2.1 20.9999 7.33333 21.4998 10L20.4998 10.5018L19.0058 9.00597C18.9246 9.12193 18.7538 9.48564 18.4998 10.5018C17.9998 12.5018 16.9998 11.5018 16.9998 10.0018L14.4998 8C13.4998 7.83333 11.3998 7.4 10.9998 7C10.5998 6.6 9.83315 7.5 9.49982 8L8.49997 7.5C8.33331 7.33333 8.09997 6.8 8.49997 6C8.89997 5.2 10.6666 4.33333 11.5 4Z",
    fill: "#4F4E65",
    stroke: "#4F4E65",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50094 11C8.50094 10.2 9.1676 10 9.50094 10C12.0019 10 13.5 10.5 13.5 11C13.5 11.4 14.5 12.5 15 13C15.5 13.1667 16.5 13.6 16.5 14C16.5 14.4 15.5 14.8333 15 15C14.5 16.5 13.3 19.4 12.5 19C11.7 18.6 11.1667 15.5 11 14C10.6 13.6 9.50063 13.8333 9.00094 14C7.00094 12 8.50094 12 8.50094 11Z",
    fill: "#4F4E65",
    stroke: "#4F4E65",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5C6.8597 7.16667 5.39925 6.5 4.26617 6.5C2 7.5 2 9.41667 2 10.25C2.37769 10.6667 3.04677 11 3.5 11C3.95323 11 4.26617 10.6667 4.26617 10.25C4.26617 10.25 4.1403 9.83333 5.5 8.5Z",
    fill: "#4F4E65",
    stroke: "#4F4E65",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.4999C4.1 12.6999 2.83333 13.1669 2 13.5002C2 15.5005 4 18.3334 5 19.4999V18.9997L5.5 16.9997C6.7 15.7997 6.5 15.333 6 14.9997C5.66667 14.9998 4.9 14.2999 4.5 13.4999Z",
    fill: "#4F4E65",
    stroke: "#4F4E65",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMonitorNavigation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/monitor-navigation.32e48ce8dfdc95248eaf4981df74751b.svg";